import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  reportAnalytics: {
    overflowX: 'hidden',
    gap: '10px',
    padding: '0px',
    '@media (min-width: 1024px)': {
      padding: '16px',
    },
  },
  downloadExcelButton: {
    alignSelf: 'flex-start',
    display: 'flex',
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    width: '100%',
    '&>.myev-MuiButton-label': {
      gap: '10px',
      justifyContent: 'center',
    },
    '@media (min-width: 640px)': {
      width: 'fit-content',
    },
  },
  downloadExcelText: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
  },
  tableContainer: {
    maxWidth: '100%',
    overflowX: 'scroll',
  },
  table: {
    '& tbody>tr': {
      '&:nth-of-type(odd):not(.no-results)': {
        backgroundColor: theme.evPalette.charcoal[100],
      },
      '&>td': { border: 'none' },
    },
  },
  tableBody: {
    '& td:first-child': {
      paddingLeft: '24px',
    },
  },
  tableHeader: {
    '& th': {
      backgroundColor: theme.evPalette.salt[100],
      fontWeight: 400,
      fontSize: '14px',
      color: theme.evPalette.charcoal[700],
      lineHeight: '24px',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
    },
  },
  tableCell: {
    fontSize: '14px',
    lineHeight: '20px',
    padding: '16px',
    whiteSpace: 'nowrap',
  },
  reportAnalyticsMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflowX: 'hidden',
    '@media (min-width: 1024px)': {
      margin: '24px',
    },
  },
  downloadExcelButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '16px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      justifyContent: 'space-between',
      '@media (min-width: 1024px)': {
        padding: '0px',
      },
    },
  },
}));
